<template>
  <span>
    <div ref="newPlaceModal" class="modal fade" tabindex="-1" role="dialog">
      <info-modal :title="place ? $t('editPlace') : $t('newPlace')">
        <div v-if="renderModal">
          <table class="table table-sm">
            <thead></thead>
            <tbody>
              <tr>
                <th scope="row">{{ $t('name') }}</th>
                <td>
                  <input v-model="name" style="width: 500px" type="text" class="form-control" />
                </td>  
              </tr>
              <tr>
                <th scope="row">{{ $t('type') }}</th>
                <td>
                  <VueSelect style="width: 500px" v-model="savePlaceType" :options="savePlaceTypes" :clearable="true" :searchable="false" >
                    <template v-slot:option="option">
                      <img style="width: 20px; height: 20px;" :src="markerIcons[option.icon]" />
                      {{ option.label }}
                    </template>
                  </VueSelect>
                  <!--<BFormSelect style="width: 500px" v-model="savePlaceType" class="mb-3">
                    <BFormSelectOption v-for="option in savePlaceTypes" :value="option">
                      {{ option.label }}
                    </BFormSelectOption>
                  </BFormSelect>--> 
                </td>
              </tr>
              <tr>
                <th scope="row">{{ $t('isApproved') }}</th>
                <td>
                  <b-form-checkbox v-model="approved"></b-form-checkbox>
                </td>
              </tr>
              <tr>
                <th scope="row">{{ $t('description') }}</th>
                <td>
                  <textarea v-model="description" class="form-control" rows="2" style="width: 500px"></textarea>
                </td>
              </tr>
              <tr>
                <th scope="row">{{ $t('coordinates') }}</th>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" :name="'coordinatesRadio2_' + (place ? place.id : '')" value=1 :id="'coordsradio1_' + (place ? place.id : '')" v-model="coordinatesRadio">
                    <label class="form-check-label" :for="'coordsradio1_' + (place ? place.id : '')">
                      {{ $t('manually') }}
                    </label>
                  </div>
                  <input :disabled="coordinatesRadio != 1" style="width: 500px" type="text" class="form-control" v-model="manualCords" />
                  <div class="form-check">
                    <input class="form-check-input" type="radio" :name="'coordinatesRadio2_' + (place ? place.id : '')" :id="'coordsradio2_' + (place ? place.id : '')" value=2 v-model="coordinatesRadio">
                    <label class="form-check-label" for="coordsradio2_">
                      {{ fromContextMenu ? $t('fromContextMenuPosition') : $t('fromMapCenter') }}: {{ mapCenterLat }}, {{ mapCenterLon }}
                    </label>
                  </div>
                  <div class="form-check disabled">
                    <input :disabled="! firstPhotoLat" class="form-check-input" type="radio" :name="'coordinatesRadio2_' + (place ? place.id : '')" :id="'coordsradio3_' + (place ? place.id : '')" value=3 v-model="coordinatesRadio">
                    <label class="form-check-label" :for="'coordsradio3_'+ (place ? place.id : '')">
                      {{ $t('fromFirstPhoto') }}: <span v-if="firstPhotoLat">{{ firstPhotoLat }}, {{ firstPhotoLon }}</span>
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">{{ $t('photos') }}</th>
                <td>
                  <table v-for="(photo, index) in placeLocalPhotoOrder" :key="photo.id" class="" style="display: inline; margin: 10px;">
                    <tr>
                      <td style="padding: 0px">
                        <img v-if="photo.image_thumb" :src="photo.get_image_thumb()" style="max-heigth: 180px; max-width: 180px; border: 1px black solid" />
                        <img v-else :src="photo.src" style="max-heigth: 180px; max-width: 180px; border: 1px black solid" />
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0px">
                        <span style="text-align: center">
                          <img v-if="photo.src" @click="removePhoto(photo)" style="cursor: pointer; width: 16px; height: 16px; float: left; margin-top: 4px;" :src="icons.trash" />
                          <img @click="index != 0 ? moveLeft(photo) : null" :style="{width: '8px', 'cursor': index == 0 ? 'arrow' : 'pointer'}" :src="index == 0 ? icons.arrowLeftDisabled : icons.arrowLeft" />&nbsp;
                          <img @click="index != placeLocalPhotoOrder.length - 1 ? moveRight(photo) : null" :style="{width: '8px', 'cursor': index == placeLocalPhotoOrder.length - 1 ? 'arrow' : 'pointer'}" :src="index == placeLocalPhotoOrder.length - 1 ? icons.arrowRightDisabled : icons.arrowRight" />
                        </span>  
                      </td>
                    </tr>    
                    <tr>
                      <td style="padding: 0px; padding-bottom: 20px;">
                        <img v-if="photo.image_thumb && photo.private" style="width: 16px; height: 16px; margin-right: 2px" :src="icons.privacy" />
                        <span style="font-size: 12px; float: right; color: gray">{{ photo.org_filename }}</span>
                      </td>
                    </tr> 
                  </table>
                  <div id="photouploaddivinner2" style="width: 48px; height: 48px;" @click="openPhotoImportFileInput" class="leaflet-touch leaflet-bar cogsbutton" va-b-tooltip.hover :title="$t('importPhotoFile')">
                    <input ref="importPhotoFileInput" type="file" style="display:none;" accept=".jpg" v-on:change="importPhotoFile" />
                    <img style="cursor: pointer; width: 28px; height: 28px;" :src="icons.camera" />
                  </div>
                </td>
              </tr>
            </tbody>    
          </table>
          <div class="modal-footer">
            <div style="width: 50%" v-if="placeSaving"><b-progress :max="100" show-progress animated>
              <b-progress-bar :value="progress" show-progress animated>
                <strong>{{ progress.toFixed(0) }}%</strong>
              </b-progress-bar>
            </b-progress></div>
            <button type="button" class="btn btn-success" :disabled="(((!name) || (!savePlaceType)) || (placeSaving))" @click="saveNewPlaceModal">
              <template v-if="placeSaving">
                <img style='height: 16px; animation: rotation 2s infinite linear;' :src="icons.spinnerWhite" />&nbsp;
              </template><strong>{{ place ? $t('save') : $t('addPlaceToMap') }}</strong>
            </button>
            <button :disabled="placeSaving" type="button" class="btn btn-primary" @click="closeNewPlaceModal">
              <strong>{{ $t('close') }}</strong>
            </button>
          </div>
        </div>  
      </info-modal>
    </div>
  </span>    
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import PlaceType from '../ts/PlaceType';
import $ from 'jquery';
import ExifReader from 'exifreader';
import { AlertStatus, DataOrigin } from '@/ts/types';
import axios from 'axios';
import Place from '@/ts/Place';
import Photo from '@/ts/Photo';
import {checkString, splitCoords} from '@/ts/utils/coords';
import {EventBus} from '@/ts/EventBus';
import { defineComponent, type PropType } from "vue";
import UploadPhoto from '@/ts/UploadPhoto';
import { error as debugError } from '@/ts/debug';

interface FileReaderEventTarget extends EventTarget {
  result: string;
}

export default defineComponent({
    extends: BaseComponent,
    data() {
        const placeLocalPhotoOrder: (Photo | UploadPhoto)[] = [];
        const savePlaceTypes: Array<{translate: string, label: string, value: PlaceType, icon: string}> = [];
        const savePlaceType: {translate: string, label: string, value: PlaceType} = null;
        const firstPhotoLon: number = null;
        const firstPhotoLat: number = null;

        return {
            name: '',
            description: '',
            photos: [] as Photo[],
            mapCenterLat: 0,
            mapCenterLon: 0,
            approved: true,
            firstPhotoLat,
            firstPhotoLon,
            placeSaving: false,
            manualCords: '',
            renderModal: false,
            progress: 0,
            photosToUpload: 0,
            photosUploaded: 0,
            fromContextMenu: false,
            firstSwitchToPhotoCoords: false,
            savePlaceType,
            savePlaceTypes,
            coordinatesRadio: 1,
            placeLocalPhotoOrder,
            updatePhotoOrder: false
        };
    },
    mounted() {
        if (this.place) {
          EventBus.$on('openSavePlaceModal' + this.place.id, this.openEditPlaceModal);
          this.placeLocalPhotoOrder = [];
          for(const photo of this.place.photos) {
            this.placeLocalPhotoOrder.push(photo);
          }
        } else {
          EventBus.$on('NewPlaceRequested', (local: boolean, latlng: L.LatLng) => {
            this.placeLocalPhotoOrder = [];
            this.openNewPlaceModal(local, latlng);
          });
        }
        this.onStorePlaceTypesChanged();
    },
    methods: {
        findPhotoCurrentPosition(photo: Photo) {
            let index = 0;
            for(const ph of this.placeLocalPhotoOrder) {
              if (ph.id == photo.id) {
                return index;
              }
              index = index + 1;
            }
            return null;
        },
        swapElements(array: (Photo | UploadPhoto)[], i: number, j: number) {
            const origin = array[i];
            array[i] = array[j];
            array[j] = origin;
        },
        moveLeft(photo: Photo) {
            const index = this.findPhotoCurrentPosition(photo);
            if (index > 0) {
              this.swapElements(this.placeLocalPhotoOrder, index, index - 1);
              this.updatePhotoOrder = true;
            }
        },
        moveRight(photo: Photo) {
            const index = this.findPhotoCurrentPosition(photo);
            if (index < this.placeLocalPhotoOrder.length - 1) {
              this.swapElements(this.placeLocalPhotoOrder, index, index + 1);
              this.updatePhotoOrder = true;
            }
        },
        removePhoto(photo: Photo) {
            this.placeLocalPhotoOrder.splice(this.placeLocalPhotoOrder.indexOf(photo), 1);
            this.refreshFirstPhotoCoords();
        },
        openNewPlaceModal(local: boolean, contextMenuLatLng: L.LatLng) {
            this.renderModal = true;
            this.name = '';
            this.description = '';
            this.coordinatesRadio = 2;
            this.savePlaceType = null;
            this.manualCords = '';
            this.approved = true;
            this.updatePhotoOrder = false;
            if (local) {
              this.mapCenterLat = Math.round(window.mainmap.getCenter().lat * 100000) / 100000;
              this.mapCenterLon = Math.round(window.mainmap.getCenter().lng * 100000) / 100000;
              this.fromContextMenu = false;
            } else {
              this.mapCenterLat = Math.round(contextMenuLatLng.lat * 100000) / 100000;
              this.mapCenterLon = Math.round(contextMenuLatLng.lng * 100000) / 100000;
              this.fromContextMenu = true;
            }
            this.firstPhotoLat = null;
            this.firstPhotoLon = null;
            this.firstSwitchToPhotoCoords = false;
            this.openModal(this.$refs.newPlaceModal);
        },
        openEditPlaceModal() {
            this.renderModal = true;
            this.name = this.place.name;
            this.description = this.place.description;
            this.manualCords = this.place.lat + ' ' + this.place.lon;
            this.coordinatesRadio = 1;
            this.savePlaceType = null;
            this.updatePhotoOrder = false;
            this.fromContextMenu = false;
            this.mapCenterLat = Math.round(window.mainmap.getCenter().lat * 100000) / 100000;
            this.mapCenterLon = Math.round(window.mainmap.getCenter().lng * 100000) / 100000;
            for (const type of this.savePlaceTypes) {
              if (type.value.id == this.place.type.id) {
                this.savePlaceType = type;
              }
            }
            this.approved = this.place.approved;
            this.firstPhotoLat = null;
            this.firstPhotoLon = null;
            this.firstSwitchToPhotoCoords = true;
            this.openModal(this.$refs.newPlaceModal);
        },
        closeNewPlaceModal() {
            this.closeModal(this.$refs.newPlaceModal);
        },
        openPhotoImportFileInput() {
            $(this.$refs.importPhotoFileInput).click();
        },
        arrayBufferToBase64(buffer: any) {
            var arrayBufferView = new Uint8Array(buffer);
            var blob = new Blob( [ arrayBufferView ], { type: "image/jpeg" } );
            var urlCreator = window.URL || window.webkitURL;
            var imageUrl = urlCreator.createObjectURL(blob);
            return imageUrl;
        },
        firstNewPhoto() {
            for(const photo of this.placeLocalPhotoOrder) {
              if (photo instanceof UploadPhoto) {
                return photo;
              }
            }
            return null;
        },
        newPhotoCount() {
            let count = 0;
            for(const photo of this.placeLocalPhotoOrder) {
              if (photo instanceof UploadPhoto) {
                count = count + 1;
              }
            }
            return count;
        },
        async refreshFirstPhotoCoords() {
            const firstNewPhoto = this.firstNewPhoto();
            if (firstNewPhoto) {
              const exifData = await ExifReader.load(firstNewPhoto.buffer, {expanded: true});
              if (exifData["gps"]["Longitude"] && exifData["gps"]["Latitude"]) {
                this.firstPhotoLon = Math.round(exifData["gps"]["Longitude"] * 100000) / 100000;
                this.firstPhotoLat = Math.round(exifData["gps"]["Latitude"] * 100000) / 100000;
              } else {
                this.firstPhotoLon = null;
                this.firstPhotoLat = null;  
              }
            } else {
              this.firstPhotoLon = null;
              this.firstPhotoLat = null;
            }
            if (((this.firstPhotoLat === null) || (this.firstPhotoLon === null)) && (this.coordinatesRadio === 3)) {
              this.coordinatesRadio = 2;
            }
            if ((this.firstPhotoLon) && (this.firstPhotoLat) && (! this.firstSwitchToPhotoCoords)) {
              this.coordinatesRadio = 3;
              this.firstSwitchToPhotoCoords = true;
            }
        },
        importPhotoFile(event: Event) {
            let lon = null;
            let lat = null;
            const files = (event.target! as HTMLInputElement).files;
            if (!files || !files.length) {
              return;
            }
            const file = files[0];
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = (onLoadEvent: Event) => {
              const buffer = (onLoadEvent.target as FileReaderEventTarget).result;
              const now = new Date();
              this.placeLocalPhotoOrder.push(new UploadPhoto(this.arrayBufferToBase64(buffer), buffer, now.getTime(), file.name, false));
              this.updatePhotoOrder = true;
              this.refreshFirstPhotoCoords()
              $(this.$refs.importPhotoFileInput).val('');
            };
            reader.onerror = (onErrorEvent: Event) => {
              $(this.$refs.importPhotoFileInput).val('');
              this.createAlert(AlertStatus.danger, this.$t('importError').toString(), 2000);
            };
        },
        downloadNewPlace(id: number) {
            axios.get(window.apiHost + 'api/places/' + id + '/').then((response) => {
              let responsePlace = response.data;
              const placetype = new PlaceType(responsePlace.type.id, responsePlace.type.name, responsePlace.type.icon, responsePlace.type.group);
              if (this.place) {
                this.place.name = responsePlace.name;
                this.place.description = responsePlace.description;
                this.place.approved = responsePlace.approved;
                this.place.lat = responsePlace.lat;
                this.place.lon = responsePlace.lon;
                this.place.type = placetype;
                this.place.photos = [];
                for (const responsePhoto of responsePlace.photo_set) {
                  const photo = new Photo(responsePhoto.id, responsePhoto.name, responsePhoto.description, responsePhoto.org_filename, responsePhoto.exif_time_taken, window.mediaHost + 'photos/' + responsePhoto.filename, window.mediaHost + 'photos/' + responsePhoto.fullhd_filename, window.mediaHost + 'photos/' + responsePhoto.thumb_filename, responsePhoto.private, responsePhoto.order, responsePhoto.past);
                  this.place.addPhoto(photo);
                }
                this.placeLocalPhotoOrder = [];
                for(const photo of this.place.photos) {
                  this.placeLocalPhotoOrder.push(photo);
                }
              } else {
                const place = new Place(responsePlace.id, responsePlace.name, responsePlace.description, responsePlace.lat, responsePlace.lon, placetype, responsePlace.approved, null, DataOrigin.maplas, true);
                for (const responsePhoto of responsePlace.photo_set) {
                  const photo = new Photo(responsePhoto.id, responsePhoto.name, responsePhoto.description, responsePhoto.org_filename, responsePhoto.exif_time_taken, window.mediaHost + 'photos/' + responsePhoto.filename, window.mediaHost + 'photos/' + responsePhoto.fullhd_filename, window.mediaHost + 'photos/' + responsePhoto.thumb_filename, responsePhoto.private, responsePhoto.order, responsePhoto.past);
                  place.addPhoto(photo);
                }
                this.$store.commit('addPlace', place);
                for(const storePlace of this.$store.state.places) {
                  if(storePlace.id == place.id) {
                    storePlace.createMarker();
                  }
                }
                this.placeLocalPhotoOrder = [];
                for(const photo of place.photos) {
                  this.placeLocalPhotoOrder.push(photo);
                }
              }
              EventBus.$emit('RefreshPlacesGroups');
            }).catch((response) => {
              debugError(response);
              this.createAlert(AlertStatus.danger, this.$t('placeRefreshError').toString(), 2000);
            });
        },
        onUploadProgress(progressEvent: ProgressEvent) {
            if (this.photosToUpload == 0) {
              this.progress = 100;
            } else {
              let part = this.photosUploaded / this.photosToUpload;
              let currentPart = ((progressEvent.loaded / progressEvent.total) / this.photosToUpload)
              this.progress = (part + currentPart) * 100
            }
        },
        async saveNewPlaceModal() {
            this.photosToUpload = this.newPhotoCount();
            this.photosUploaded = 0;
            let obj = {'name': this.name, 'description': this.description, 'type': this.savePlaceType.value.id, 'approved': this.approved, 'lat': null as number, 'lon': null as number, photo_set: [] as Photo[]};
            obj.name = this.name;
            obj.description = this.description;
            obj.type = this.savePlaceType.value.id;
            obj.approved = this.approved;
            obj.photo_set = [];
            if (this.coordinatesRadio == 1) {
              if (! checkString(this.manualCords)) {
                this.createAlert(AlertStatus.danger, this.$t('coordsError').toString(), 2000);
                return;
              } else {
                const parts = splitCoords(this.manualCords);
                obj.lat = parts[0];
                obj.lon = parts[1];
              }
            }
            if (this.coordinatesRadio == 2) {
              obj.lat = this.mapCenterLat;
              obj.lon = this.mapCenterLon;
            }
            if (this.coordinatesRadio == 3) {
              obj.lat = this.firstPhotoLat;
              obj.lon = this.firstPhotoLon;
            }
            this.placeSaving = true;
            let placeSaved = false;
            let photosSaved = false;
            try {
              let response = null;
              if (this.place) {
                response = await axios.patch(window.apiHost + `api/places/${this.place.id}/`, obj);
                this.place.lat = obj.lat;
                this.place.lon = obj.lon;
                this.place.getMarker().setLatLng([this.place.lat, this.place.lon]);
              } else {
                response = await axios.post(window.apiHost + `api/places/`, obj);
              }
              placeSaved = true;
              if (this.updatePhotoOrder) {
                let order = 1;
                for(const photo of this.placeLocalPhotoOrder) {
                  if (photo instanceof Photo) {
                    const response_place_order = await axios.patch(window.apiHost + `api/photos/${photo.id}/`, {order: order});
                  }
                  if (photo instanceof UploadPhoto) {
                    let form_data = new FormData();
                    form_data.append('name', '');
                    form_data.append('description', '');
                    form_data.append('org_filename', photo.org_filename);
                    form_data.append('place', response.data.id);
                    //@ts-ignore
                    form_data.append('private', photo.private_photo);
                    //@ts-ignore
                    form_data.append('order', order);
                    //@ts-ignore
                    form_data.append('image', new Blob([new Uint8Array(photo.buffer)], {type: 'image/jpeg'}), '1.jpg');
                    let headers = {'Accept': 'application/json', 'Content-Type': 'multipart/form-data'}
                    //@ts-ignore
                    let response_photo = await axios.post(window.apiHost + 'api/photos/', form_data, {headers: headers, onUploadProgress: this.onUploadProgress})
                    this.photosUploaded = this.photosUploaded + 1;
                  }
                  order = order + 1;
                }
              }
              photosSaved = true;
              this.downloadNewPlace(response.data.id);
              setTimeout(() => {
                if (this.place) {
                  this.place.changeMarkerSize(this.$store.state.zoomLevel);
                }
              }, 500);
              this.createAlert(AlertStatus.success, this.$t('placeSaved').toString(), 2000);
              this.closeNewPlaceModal();
              window.mainmap.setView([obj.lat, obj.lon], window.activeLayer.options.maxNativeZoom || window.activeLayer.options.maxZoom);
            } catch(err) {
              if (! placeSaved) {
                this.createAlert(AlertStatus.danger, this.$t('placeSavedError').toString(), 2000);
              } else if (! photosSaved) {
                this.createAlert(AlertStatus.danger, this.$t('photoSavedError').toString(), 2000);
                window.mainmap.setView([obj.lat, obj.lon], window.mainmap.getMaxZoom());
                this.closeNewPlaceModal();
              } else {
                this.createAlert(AlertStatus.danger, this.$t('placeRefreshError').toString(), 2000);
                window.mainmap.setView([obj.lat, obj.lon], window.mainmap.getMaxZoom());
                this.closeNewPlaceModal();
              }
            } finally {
              this.placeSaving = false;
            }
        },
        onStorePlaceTypesChanged() {
            this.savePlaceTypes = [];
            for (const placeType of this.$store.state.placeTypes) {
              //@ts-ignore
              this.savePlaceTypes.push({translate: placeType.name, label: '', value: placeType, icon: placeType.icon});
            }
            this.translateAndAddArrayToTranslator(this.savePlaceTypes);
        }
    },
    props: {
        place: { required: false,
            type: Object as PropType<Place>
        }
    },
    watch: {
        "$store.state.placeTypes": [{
            handler: "onStorePlaceTypesChanged"
        }]
    }
})


</script>